export function formatPlural(str,n) {
    if (n == 1) return str;
    return `${str}s`
}